import React, { useEffect, useState } from 'react';
import Header from './Header';
import Hero from './Hero';
import Skills from './Skills';
import Portfolio from './Portfolio';
import WorkExperiences from './WorkExperience';
import GetIntouch from './GetIntouch';
import Footer from './Footer';
import SectionHeader from './SectionHeader';
import { animateScroll as scroll } from 'react-scroll';
import { Icon } from '@iconify/react';

function MyApp() {
	const [isVisible, setIsVisible] = useState(false);
	useEffect(() => {
		window.addEventListener('scroll', () => {
			if (window.scrollY > 100) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		});
	}, []);

	return (
		<div className="bg-app min-h-screen pb-16 selection:bg-pink-400 [&>_*]:transition-all [&>_*]:duration-200 [&>_*]:ease-linear">
			<div className="font-poppins">
				<div className="">
					{/* px-4 sm:px-12 md:px-16 xl:px-0 max-w-7xl */}
					<Header />
					<Hero />
					<div className="flex flex-col mt-5 sm:gap-y-16 md:gap-y-16">
						<SectionHeader text="Technical-skills" id="skills" />
						<Skills />
						<SectionHeader
							text="Portfolio-projects"
							id="projects"
						/>
						<Portfolio />
						<SectionHeader
							text="Work experience"
							id="experiences"
						/>
						<WorkExperiences />
						<SectionHeader text="Get in touch" id="contacts" />
						<GetIntouch />
						<Footer />
					</div>
				</div>
			</div>

			{/* Back to top button */}
			<button
				hidden={!isVisible}
				onClick={() => {
					scroll.scrollToTop();
				}}
				className="fixed animate-bounce bottom-1/4 right-16 text-3xl text-primary bg-blue-200 rounded-full p-3 shadow-lg"
			>
				<Icon icon="ep:arrow-up" />
			</button>
		</div>
	);
}

export default MyApp;
